'use strict';

const debounce = require('./modules/helpers/debounce');
const gtm = require('./modules/google').tagManager;

const tabsHolder = '.js-tabs-holder';
const tabButton = '.js-tab-item';
const tabLine = '.js-tab-line';
const tabContent = '.js-tab-content';
const tabExpandingContent = '.js-tab-expanding-content';
const windowTablet = $(window).width() > 767 & $(window).width() < 1024;

/**
 * @description make first tab and first tab content selected on page load
**/
function onLoadTabs() {
    if ($(tabsHolder).length) {
        $(tabsHolder).each(function () {
            const $this = $(this);
            const $firstTab = $this.find('.js-tabs li:first');

            $('.js-tab-content:first').addClass('active').removeAttr('aria-hidden');
            $firstTab.find(tabButton).addClass('selected');
            ingredientsExpand();
        });
    }
}

function tabsAndAccordiansContent() {
    $('.js-tab-content-inner').each(function() {
        $(this).html($(this).html().trim());
    });
    $('.js-accordion-content').each(function(){
        $(this).html($(this).html().trim());
    });
}

/**
 * @description show / hide tab content
**/
function tabsToggle() {
    $(tabButton).on('click', function (e, shouldSkipDataLayerPush) {
        const $this = $(this);
        const $parent = $this.parents(tabsHolder);
        const $tabs = $parent.find('.js-tabs');
        const thisIndex = $this.parent().index();
        const thisWidth = $this.width();
        const tabsPosition = $tabs.position().left;
        const thisPosition = $this.parent().position().left;
        const thisCorrectedPosition = -1 * tabsPosition + thisPosition;

        if (!$this.hasClass('selected')) {
            if (!shouldSkipDataLayerPush) {
                gtm.pushPDPTabsEvent($this, tabsHolder);
            }
            if (tabsPosition === 0) {
                $parent.find(tabLine).css({
                    'left' : thisPosition,
                    'width' : thisWidth
                });
            } else {
                $parent.find(tabLine).css({
                    'left' : thisCorrectedPosition,
                    'width' : thisWidth
                });
            }

            $parent.find(tabContent).removeClass('active').attr('aria-hidden', 'true');
            $parent.find('.js-tab-content:eq(' + thisIndex + ')').stop().addClass('active').removeAttr('aria-hidden');

            $parent.find(tabButton).removeClass('selected');
            $this.addClass('selected');
        }
    });

    $(document).on('keyup', tabButton, function(){
        if (event.keyCode == 13){
            $(this).click();
        }
    });
}

/**
 * @description check if there is more content for ingredients tab content
**/
function ingredientsExpand() {
    if ($(tabExpandingContent).length) {
        $(tabExpandingContent).each(function () {
            const $this = $(this);
            const boxHeight = $this.outerHeight();
            const parentHeight = $this.parent().outerHeight() + 10;

            if (boxHeight > parentHeight) {
                $this.parents('.js-ingredients-tab-content').addClass('hidden-content');
            }
        });
    }
}

/**
 * @description read more / show less in ingredients tab content
**/
function ingredientsToggle() {
    $('.js-toggle-tab-ingredients').on('click', function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).parent('.js-ingredients-tab-content').find('.js-ingredient-tab-content-inner').css('max-height', 5000);
            $(this).parent('.js-ingredients-tab-content').css('height', 'auto');
        } else {
            $(this).removeClass('active');
            $(this).parent('.js-ingredients-tab-content').find('.js-ingredient-tab-content-inner').css('max-height', '');
            if (windowTablet) {
                $('html, body').animate({scrollTop: ($(this).parents('.js-tabs-holder').offset().top)}, 600);
            }
        }
    });
}

/**
 * @description Initialize block
 */
function initBlock() {
    onLoadTabs();
    tabsToggle();
    tabsAndAccordiansContent();
    ingredientsToggle();
}

/**
 * @description Initialize event handlers for the tabs
 */

function initializeEvents() {
    if ($(tabsHolder).length || $(tabExpandingContent).length) {
        $(window).resize(debounce(function () {
            ingredientsExpand();
        }, 200));
    }
}

const tabs = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = tabs;
